import { useEffect, useState } from 'react';
import {
    AlertInfoIcon,
    AlertSuccessIcon,
    AlertWarningIcon,
} from '../icons/icons';
import './SusyAlert.css';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

export enum SusyAlertType {
    INFO = 'info',
    WARNING = 'warning',
    SUCCESS = 'success',
}

interface IProps {
    type: SusyAlertType;
    header?: string;
    text: string;
    dataTestId?: string;
    className?: string;
    hideLongText?: boolean;
    rightInsert?: JSX.Element;
    hideIcon?: boolean;
}

const NUMBER_OF_CHARS_TO_SHOW = 300;

export const SuSyAlert = (props: IProps) => {
    const [showAllText, setShowAllText] = useState(false);
    const [showReadAllButton, setShowReadAllButton] = useState(true);

    const localization = useSelector(
        (state: RootState) =>
            state.localization.localizationStrings.susy.shared.susyAlert
    );

    const renderIcon = () => {
        switch (props.type) {
            case SusyAlertType.INFO:
                return <AlertInfoIcon />;
            case SusyAlertType.WARNING:
                return <AlertWarningIcon />;
            case SusyAlertType.SUCCESS:
                return <AlertSuccessIcon />;
        }
    };

    useEffect(() => {
        if (
            !props.hideLongText ||
            props.text.length <= NUMBER_OF_CHARS_TO_SHOW
        ) {
            setShowReadAllButton(false);
            setShowAllText(true);
        }
    }, []);

    const getTeaseText = () => {
        return `${props.text.substring(0, NUMBER_OF_CHARS_TO_SHOW)}...`;
    };

    const renderTextElement = () => {
        return showAllText || props.text.length <= NUMBER_OF_CHARS_TO_SHOW ? (
            <div>{props.text}</div>
        ) : (
            <div>{getTeaseText()}</div>
        );
    };

    const renderShowMoreElement = () => (
        <div className='susy-alert-expand-collapse-text'>
            {showReadAllButton &&
                props.hideLongText &&
                props.text.length > NUMBER_OF_CHARS_TO_SHOW && (
                    <span
                        className='susy-read-more'
                        onClick={() => setShowAllText(() => !showAllText)}
                    >
                        {showAllText
                            ? localization.showLess
                            : localization.showMore}
                    </span>
                )}
        </div>
    );

    return (
        <div
            data-testid={props.dataTestId ?? 'susy-alert'}
            className={`susy-alert susy-alert-${props.type} ${
                props.className
            } ${props.hideLongText ? 'w-100' : ''}`}
        >
            <div className='d-flex susy-alert-text-opacity'>
                {!props.hideIcon && (
                    <div className='mr-3 susy-alert-icon'>{renderIcon()}</div>
                )}

                <div>
                    <div className='susy-alert-header'>{props.header}</div>
                    {renderTextElement()}
                    {renderShowMoreElement()}
                </div>
            </div>
            {props.rightInsert}
        </div>
    );
};
